import { render, staticRenderFns } from "./PeBrandChip.vue?vue&type=template&id=5b8bc88a&"
import script from "./PeBrandChip.vue?vue&type=script&lang=js&"
export * from "./PeBrandChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports